import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  header: string
  body: string
}

export default function EmptyState({ header, body }: Props) {
  return (
    <Box
      flexDirection="column"
      gap="s8"
      alignItems="center"
      justifyContent="center"
      border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
      borderRadius={{ all: 'abs008' }}
      padding="s32"
      textAlign="center"
    >
      <Text size="300" color="black" weight="bold">
        {header}
      </Text>
      <Text size="300" color="black">
        {body}
      </Text>
    </Box>
  )
}
